import { motion, useInView } from 'framer-motion';
import { useRef, useEffect } from 'react';

const WorksSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });
  
  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.3
      }
    }
  };
  
  const itemVariants = {
    hidden: { 
      y: 50, 
      opacity: 0,
      scale: 0.95
    },
    visible: {
      y: 0,
      opacity: 1,
      scale: 1,
      transition: {
        type: "spring",
        damping: 12,
        stiffness: 100
      }
    }
  };

  return (
    <section ref={ref} className="works-01 top">
      <div className="works-01-container">
        <motion.div 
          className="section-header"
          variants={containerVariants}
          initial="hidden"
          animate={isInView ? "visible" : "hidden"}
        >
          <motion.div className="section-heade-titile" variants={itemVariants}>
            <div className="heading-04">Our Works -</div>
          </motion.div>
          
          <div className="section-header-text max-767">
            <div className="overflow-hidden">
              <motion.h2 className="heading-02 uper-case" variants={itemVariants}>
                Our Work Speaks 
              </motion.h2>
            </div>
            <div className="overflow-hidden">
              <motion.h2 className="heading-02 uper-case" variants={itemVariants}>
                Than Words
              </motion.h2>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default WorksSection;